export default __webpack_public_path__ + "static/media/24.1a4743a4.jpg";